import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { MrfiktivRealtimeSessionControllerFindAllParamsGen } from "../v1/data-contracts";
import { CallSessionService } from "../v1/CallSessionService";

/**
 * Communicate with Call Session API
 */
class CallService {
  private proxy: CallSessionService;

  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new CallSessionService(mrfiktivHttpClientProvider.client());
  }

  /**
   * Get all call sessions for a partner
   */
  async getAll(query: MrfiktivRealtimeSessionControllerFindAllParamsGen) {
    return (await this.proxy.realtimeSessionControllerFindAll(query)).data;
  }

  /**
   * Get one call session by id
   */
  async getOne(partnerId: string, sessionId: string) {
    return (await this.proxy.realtimeSessionControllerFindOne(partnerId, sessionId)).data;
  }
}

export default new CallService(new MrfiktivHttpClientProvider());
